import React from "react";
import { IconAlertTriangleFilled } from "@tabler/icons-react";

const FullSubpageError = ({ title, errorCode, description, userMessage }) => {
	return (
		<div
			style={{
				display: "flex",
				marginTop: 60,
				alignItems: "center",
				flexDirection: "column",
			}}
		>
			<IconAlertTriangleFilled size={60} color={"var(--lw-darker-red)"} />
			<h2 style={{ marginBottom: 10 }}>{title}</h2>
			{errorCode ? (
				<pre
					style={{
						backgroundColor: "var(--lw-light-grey)",
						padding: "8px 12px",
						borderRadius: 4,
						fontSize: 14,
						marginBottom: 10,
					}}
				>
					Error Code: {errorCode}
				</pre>
			) : null}
			{userMessage ? (
				<p style={{ fontSize: 18, marginBottom: 5 }}>{userMessage}</p>
			) : null}
			{description ? (
				<p style={{ color: "var(--lw-dark-grey)", fontSize: 14 }}>
					{description}
				</p>
			) : null}
		</div>
	);
};

export default FullSubpageError;
